module.exports = __webpack_public_path__ + "html/file-input.template.html";